import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { UiFormFieldAppearance, UiFormFieldType } from './ui-form-field.types';
import { UiLabelTranslatePipe } from '../ui-label-translate.pipe';

@Component({
  selector: 'ui-form-field',
  standalone: true,
  imports: [UiLabelTranslatePipe],
  templateUrl: './ui-form-field.component.html',
  styleUrl: './ui-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiFormFieldComponent {
  readonly appearance = input<UiFormFieldAppearance>('outline');
  readonly label = input('');
  readonly value = input<string>('');
  readonly type = input<UiFormFieldType>('text');
  readonly placeholder = input('');
  readonly id = input('');
  readonly disabled = input(false);
  readonly required = input(false);
  readonly readonly = input(false);
  readonly error = input('');
  readonly hint = input('');
  readonly rows = input(3);
  readonly min = input<string>('');
  readonly max = input<string>('');
  readonly step = input<string>('');
  readonly valueChange = output<string>();

  onValueChange(value: string): void {
    this.valueChange.emit(value);
  }
}
